import { Dialog, DialogBody, DialogContent, DialogFooter, DialogHeader } from '@d-edge/overnight-hotelier-react'
import type { ReactNode } from 'react'
import { useRefreshPause } from '@/app/RefreshContext'
import styles from './ui.module.css'

interface ModalProps {
  title: ReactNode
  onClose: () => void
  children: ReactNode
  size?: 'md' | 'lg' | 'xl' | 'full'
  footer?: ReactNode
  /** Extra controls rendered under the title, above the body. */
  headerExtra?: ReactNode
}

const sizeClass = { md: styles.dialogMd, lg: styles.dialogLg, xl: styles.dialogXl, full: styles.dialogFull }

/** Kit dialog that is open for as long as it is mounted. While open the dashboard's auto refresh is paused. */
export function Modal({ title, onClose, children, size = 'lg', footer, headerExtra }: ModalProps) {
  useRefreshPause()
  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent className={`${styles.dialog} ${sizeClass[size]}`}>
        <DialogHeader closeLabel="Close">{title}</DialogHeader>
        {headerExtra && <div className={styles.dialogTools}>{headerExtra}</div>}
        <DialogBody className={styles.dialogBody}>{children}</DialogBody>
        {footer && <DialogFooter>{footer}</DialogFooter>}
      </DialogContent>
    </Dialog>
  )
}
